
import { cn } from "@/lib/utils";

interface CooksyLogoProps {
  className?: string;
  showText?: boolean;
}

export const CooksyLogo = ({ className, showText = true }: CooksyLogoProps) => {
  return (
    <div className="flex items-center gap-2">
      <img 
        src="/lovable-uploads/a5d7caaa-c143-482d-89c1-5098a3b87da8.png" 
        alt="HomePlate Logo" 
        className={cn("h-8", className)} 
      />
    </div>
  );
};
